import { ChecklistItem } from "@/state/ChecklistItem";
import { Task } from "@/state/Task";
import { startOfWeek } from "date-fns";

export const taskFilter = (task: Task) => (item: ChecklistItem) => item.task === task.uuid;
export const notScheduledFilter = (startDate: Date) => {
    // Фильтр задач, которые не назначены на какое-то время или которые были назначены и не выполнены еще на прошлой неделе
    
    return (task: ChecklistItem) => 1
};
export const getFirstDay = (forDate?: Date) => {
    const date = forDate || new Date();
    return startOfWeek(date, { weekStartsOn: 1 }); // monday
};
